export default "__VITE_ASSET__7df616ce__"